import React from 'react';
import styles from './Tabs.module.scss';

import { useTicketsDashboardActions, useTicketsDashboardSelector } from 'hooks/TicketsDashboard';

import ToggleBar from 'components/ToggleBars/ToggleBar';

import { TOGGLE_BUTTONS } from '../../helpers';

export default function DashboardTabs() {
  const { setTabAction } = useTicketsDashboardActions();
  const { tab } = useTicketsDashboardSelector();

  const clickTab = (tab) => setTabAction(tab);

  return (
    <ToggleBar
      buttons={TOGGLE_BUTTONS}
      onChange={clickTab}
      selectedTab={tab}
      classes={styles.bar}
    />
  );
}
